import { render, staticRenderFns } from "./link-form.vue?vue&type=template&id=5dcc22b5&scoped=true&"
import script from "./link-form.vue?vue&type=script&lang=js&"
export * from "./link-form.vue?vue&type=script&lang=js&"
import style0 from "./link-form.vue?vue&type=style&index=0&id=5dcc22b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcc22b5",
  null
  
)

export default component.exports